import { trigger, state, style, transition, animate } from '@angular/animations';

export const FlipAnimation = trigger('flip', [
  state('false', style({ transform: 'rotate({{rotate}}deg) scaleY(0)' }), { params: { rotate: 0 } }),
  state('true', style({ transform: 'rotate({{rotate}}deg) scaleY(1)' }), { params: { rotate: 0 } }),
  transition('false => true', animate('75ms 75ms')),
  transition('true => false', animate('75ms')),
]);
